export default __webpack_public_path__ + "static/media/164.ac76ff8b.svg";